import { Log } from '../../shared/log';
const log = Log.getLogger('AuthGuard');

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const loggedIn = this.auth.isLoggedIn();
    if (loggedIn) {
      return true;
    } else {
      this.auth.login(1);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./app/services/auth/auth-guard.service.ts